// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nselect[data-v-468d2fa0] {\n  width: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
